import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const gameVuex = createNamespacedHelpers("game");
export default {
  name: "mTierBenefits",
  props: {
    isCurrent: {
      default: false
    }
  },
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo", "myInfo"]),
    ...gameVuex.mapState(["propertyList", "gameProgress"]),
    levelInfo() {
      return this.$route.path == "/center" || this.$route.path != "/center" && this.isCurrent ? this.gameProgress.currentLevel : this.gameProgress.nextLevel;
    },
    rewardsName() {
      if (this.levelInfo === this.gameProgress.currentLevel) {
        return "currentRewards";
      } else {
        return "nextRewards";
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
};